import DateRangeFilter from 'components/ReactTable/Filters/DateRangeFilter';
import MultiSelectFilter from 'components/ReactTable/Filters/MultiSelectFilter';

// note: for the sorting to work, the 'accessor' properties below must have the same name as the backend property to be sorted by
const statementUploadsTabColumnDefs = () => [
  {
    Header: 'File Name',
    accessor: 'originalFileName',
    className: 'col-40p upload-file-name',
  },
  {
    Header: 'Status',
    accessor: 'documentUploadStatus',
    Filter: MultiSelectFilter,
    className: 'col-10p upload-status',
  },
  {
    Header: 'Date Uploaded',
    accessor: 'documentUploadDate',
    Cell: ({ row }) => row.original.documentUploadDateDisplay || '',
    Filter: DateRangeFilter,
    className: 'col-15p upload-date',
    disableSortBy: false
  },
  {
    Header: 'Uploaded By',
    accessor: 'uploadedBy',
    disableSortBy: true,
    className: 'col-10p upload-uploaded-by',
    disableFilters: true
  },
  {
    Header: 'Files',
    accessor: 'fileCount',
    className: 'col-5p upload-file-count',
    disableFilters: true
  },
  {
    Header: 'Forms',
    accessor: 'formCount',
    className: 'col-5p upload-form-count',
    disableFilters: true
  },
  {
    Header: 'Supporting Docs',
    accessor: 'supportingDocumentCount',
    className: 'col-10p upload-supporting-doc-count',
    disableFilters: true
  },
];

export default statementUploadsTabColumnDefs;
